import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';

class SpotlightReportsService extends ViveApiBaseService {
  public async usesSpotlightVendors(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<{ usesSpotlightVendors: boolean }> {
    const { options, pathParams } = params;
    return await this.sendGet<{ usesSpotlightVendors: boolean }>({
      apiEndpoint:
        'companies/:companyId/spotlight-reports/uses-spotlight-vendors',
      options,
      pathParams
    });
  }

  public async generateVendorKpiReport(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams: { startDate: string; endDate: string };
  }): Promise<Blob> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<Blob>({
      apiEndpoint: 'companies/:companyId/spotlight-reports/vendor-kpi',
      options: { ...options, responseType: 'blob' },
      pathParams,
      queryParams
    });
  }
}

export const spotlightReportsService = new SpotlightReportsService();
